import SkeletonBase from "newui/components/Skeleton";

interface ClarificationsStepProps {
	rfxId: number;
	rfxSubmissionId?: number;
	isLoading?: boolean;
}

export const ClarificationsStep: React.FC<ClarificationsStepProps> = ({
	rfxId,
	rfxSubmissionId,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	return (
		<div data-testid="clarifications-step">
			<p className="text-sm text-gray-500 mb-4">
				Raise clarification questions with suppliers to gather any additional information needed.
			</p>
			{/* TODO: Render clarifications management interface when API is available */}
			<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
				Clarifications management will appear here.
			</div>
		</div>
	);
};
